import { geoMatchAddress } from './geoMatchInterfaces';
import { StyledAddressCard } from './styles/SelectMismatchStyles';
import { OrigineColors, disabledColor } from './styles/common';
import AddressCardContent from '@features/eligibility/select/AddressCardContent';
import { HouseDoorFill } from 'react-bootstrap-icons';

import React from 'react';
import styled from 'styled-components';
import theme from '@theme';

const StyledAddressesCardTitle = styled.div`
  font-size: ${theme.fonts.size.xs};
  font-weight: ${theme.fonts.weight.medium};
`;

const GeoMatchAddressesCard: React.FC<{
  address: geoMatchAddress;
  selected?: boolean;
  validate: (address: geoMatchAddress) => void;
}> = ({ address, selected = false, validate }) => {
  const props = {
    className: 'clickable ' + (selected ? 'select ' : ' '),
    color: OrigineColors[address.origine_type],
    selected: selected,
    onClick: () => validate(address)
  };

  const disabledProps = {
    color: disabledColor
  };

  return (
    <StyledAddressCard {...(address.has_fix_mismatch_request ? disabledProps : props)}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
        <StyledAddressesCardTitle as="h6">{address.name}</StyledAddressesCardTitle>
      </div>
      <>
        {address.batiment_immeuble && (
          <AddressCardContent
            icon={<HouseDoorFill size="13" />}
            text={<>{address.batiment_immeuble}</>}
          />
        )}
      </>
    </StyledAddressCard>
  );
};

export default GeoMatchAddressesCard;
